import { useState, useEffect } from 'react';
import api from '../../../api/api';
import { NOTIFICATION_VARIANT } from '../../../constants/types';
import { useNotifications } from '../../../Providers/NotificationsProvider/NotificationsProvider';
import { handleRequestHelper } from '../../../utils/helpers';

export const useProducerPayoutConfigPage = (producerId) => {
  const { showNotification } = useNotifications();
  const [payoutConfig, setPayoutConfig] = useState();
  const [loading, setLoading] = useState(true);

  const getPayoutConfig = async () => {
    setLoading(true);
    await handleRequestHelper({
      endpoint: () => api.getProducerPayoutConfig(producerId),
      onSuccess: ({ producerPayoutConfig }) => {
        setPayoutConfig(producerPayoutConfig);
        setLoading(false);
      },
      onFailure: () => {
        showNotification('No se pudo cargar la información financiera', NOTIFICATION_VARIANT.ERROR);
      },
    });
  };

  useEffect(() => {
    getPayoutConfig();
  }, []);

  const handleSubmit = async (formState) => {
    setLoading(true);
    await handleRequestHelper({
      endpoint: () => api.updateProducerPayoutConfig(producerId, formState),
      showNotification,
      onSuccess: () => {
        showNotification('Información financiera actualizada', NOTIFICATION_VARIANT.SUCCESS);
        getPayoutConfig();
      },
      onFailure: () =>
        showNotification(
          'No se pudo actualizar la información financiera',
          NOTIFICATION_VARIANT.ERROR
        ),
    });
    setLoading(false);
  };

  return { payoutConfig, handleSubmit, loading };
};
